Librarian.Modules.Duplicates = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["load", "onLoad", "renderDuplicates", "sendSelected", "applyFilters", "resize"],

    options: {
        classPrefix: "modules-duplicates-",
        height: "auto",
        minHeight: 300
    },

    datePickers: {},
    currentTab: "scheduled",
    grid: null,

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);

        if (this.options.currentTab) {
            this.currentTab = this.options.currentTab;
        }
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();
        this.wrapperEl.addClass("ecomm-grid");

        var contentUrl = Librarian.path.getLayoutsPath() + "pages/duplicates.html";
        new Librarian.Request.HTML({
            url: contentUrl,
            update:  this.containerEl,
            onSuccess: this.onLoad
        }).send();
    },

    onLoad: function() {
        var contEl = $(this.containerEl),
            fromDateEl = contEl.getElement(".fromDate"),
            fromIconEl = contEl.getElement(".fromIcon"),
            toDateEl = contEl.getElement(".toDate"),
            toIconEl = contEl.getElement(".toIcon"),
            toDay = new Date(),
            fromDay = new Date(toDay.getFullYear(), toDay.getMonth() - 1, toDay.getDay());

        fromDateEl.value = fromDay.format("%x");

        this.datePickers["from"] = Librarian.Utils.setUpDatePicker2(fromDateEl, fromIconEl);
        this.datePickers["to"] = Librarian.Utils.setUpDatePicker2(toDateEl, toIconEl);

        var itemEl = contEl.getElement(".goButton");
        if (itemEl)
            itemEl.addOnClick(this.applyFilters, this);

        var gridPanel = contEl.getElement(".gridPanel");
        if (gridPanel) {
            var gridButtonClick = function(name, grid) {
                    if (name == Librarian.Lang.getString("scheduled")) {
                        this.currentTab = "scheduled";
                        grid.options.url = Librarian.path.getEventUrl("getscheventswdup") + "&out=dgrid&expand=1";
                        grid.draw();
                        grid.loadData();
                    }
                    else if (name == Librarian.Lang.getString("sent")) {
                        this.currentTab = "sent";
                        grid.options.url = Librarian.path.getEventUrl("getareventswdup") + "&out=dgrid&expand=1";
                        grid.draw();
                        grid.loadData();
                    }

                    grid.options.buttons.forEach(function(buttonObj) {
                        if (buttonObj && buttonObj.element) {
                            if (buttonObj.name == name) {
                                buttonObj.bclass = "gridTab gridCurrentTab";
                                buttonObj.element.className = "gridTab gridCurrentTab";
                            }
                            else {
                                buttonObj.bclass = "gridTab";
                                buttonObj.element.className = "gridTab";
                            }
                        }
                    });
                },
                renderDateTimeString = function(data, row, columnData) {
                    var date = data[columnData.dataIndex];
                    if (date)
                        return Librarian.Utils.extractDateFromString(date).format("%m/%d/%Y %l:%M %p");
                    else
                        return "N/A";
                },
                renderDateString = function(data, row, columnData) {
                    var date = data[columnData.dataIndex];
                    if (date)
                        return Librarian.Utils.extractDateFromString(date).format("%m/%d/%Y");
                    else
                        return "N/A";
                },
                renderRecipients = function(data /*, row, columnData*/) {
                    if (!data.recipients || data.recipients.length == 0)
                        return '';

                    var str = data.recipients[0].email;
                    if (data.recipients.length > 1)
                        str += Librarian.Lang.getArgString("and_more", (data.recipients.length - 1));
                    return str;
                },
                onRowDblClick = function(obj) {
                    var row = obj.row, grid = obj.target,
                        eventInfo = grid.options.data[row],
                        detailWindow = new Librarian.EventDetailsWindow({ eventId: eventInfo.eventid, grid: grid });
                    detailWindow.show();
                },

                cmu = [
                    {
                        header: Librarian.Lang.getString("subject"),
                        dataIndex: "name",
                        dataType: "string",
                        width: 300
                    },
                    {
                        header: Librarian.Lang.getString("eventgroup"),
                        dataIndex: "groupname",
                        dataType: "string",
                        width: 300
                    },
                    {
                        header: Librarian.Lang.getString("event_senddate"),
                        dataIndex: "exectime",
                        dataType: "string",
                        labelFunction: renderDateTimeString,
                        width: 175,
                        noResize: true
                    }
                ],
                model = cmu,
                url = Librarian.path.getEventUrl("getareventswdup") + "&out=dgrid&expand=1";

            if (this.currentTab == "scheduled") 
                url = Librarian.path.getEventUrl("getscheventswdup") + "&out=dgrid&expand=1";

            var bclassSent = "gridTab";
            var bclassScheduled = "gridTab gridCurrentTab";

            if (this.currentTab == "sent") {
                bclassSent = "gridTab gridCurrentTab";
                bclassScheduled = "gridTab";
            }
            this.grid = new omniGrid(gridPanel, {
                buttons: [
                    { name: Librarian.Lang.getString("scheduled"), bclass: bclassScheduled, onclick: gridButtonClick.bind(this) },
                    { name: Librarian.Lang.getString("sent"), bclass: bclassSent, onclick: gridButtonClick.bind(this) }
                ],
                columnModel: model,
                url: url,
                pagination: true,
                serverSort: false,
                filterHide: true,
                filterHideCls: "hide",
                filterSelectedCls: "filter",
                accordion: true,
                accordionRenderer: this.renderDuplicates,
                alternaterows: true,
                showHeader: true,
                sortHeader: true,
                resizeColumns: true,
                multipleSelection: true,
                width: 800,
                height: 305,
                perPage: 20,
                resizable: false,
                startDate: fromDateEl.value
            });
            this.grid.addEvent("dblclick", onRowDblClick.bind(this));
            this.resize();
        }
    },
    
    renderDuplicates: function(obj) {
        var contEl = obj.parent;
        var data = obj.rowdata;

        contEl.setStyle("padding", "10px 20px");

        if (data.recipients && data.recipients.length) {
            var sendEl = new Element("input[type=button]", { "class": "pure-button pure-button-primary right" }).inject(contEl);
            sendEl.setAttribute("value", "Send Selected");
            sendEl.addOnClick(function() {
                this.sendSelected(obj);
            }.bind(this));

            data.recipients.forEach(function(recipient) {    
                var recipCont = new Element("div").inject(contEl);
                var labelEl = new Element("label").inject(recipCont);
                var checkEl = new Element("input[type=checkbox]").inject(labelEl);
                checkEl.data = recipient;
                if ((recipient.flags & 2) == 2)
                    checkEl.checked = true;
                
                var name = recipient.displayname;
                if (!name.contains('@'))
                    name += " <" + recipient.email + ">";
                var nameEl = new Element("span", { text: name, "class": "spacerLeftMd" }).inject(labelEl);
            });
        }
    },

    sendSelected: function(obj) {
        var contEl = obj.parent;
        var data = obj.rowdata;

        var method,
            checkboxes,
            recipients = [];
        
        if (data.archived) {
            method = "sendardup";
            checkboxes = contEl.getElements("input[type=checkbox]:checked");
            recipients = checkboxes.map(function(checkbox) {
                var recipient = checkbox.data;
                recipient.flags = 2;
                return recipient;
            });
        } 
        else {
            method = "upschdup";
            checkboxes = contEl.getElements("input[type=checkbox]");
            recipients = checkboxes.map(function(checkbox) {
                var recipient = checkbox.data;
                recipient.flags = checkbox.checked ? 2 : 0;
                return recipient;
            });
        }

        var url = Librarian.path.getEventUrl(method) + "&in=json&eid=" + data.eventid;
        new Librarian.Request({
            url: url,
            method: "post",
            data: Base64.encode(JSON.stringify(recipients)),
            onSuccess: function() {
                Librarian.Utils.notification("Success");
                
                this.grid.refresh();
            }.bind(this)
        }).send();
    },

    applyFilters: function() {
        var contEl = $(this.containerEl);
        if (!contEl)
            return;

        var itemEl = contEl.getElement(".fromDate");
        if (itemEl)
            this.grid.options.startDate = itemEl.value;

        itemEl = contEl.getElement(".toDate");
        if (itemEl)
            this.grid.options.endDate = itemEl.value;

        var filterKey = '';
        itemEl = this.containerEl.getElement(".searchBox");
        if (itemEl)
            filterKey = itemEl.value;

        this.grid.filter(filterKey, "contains", ["name"]);
    },

    resize: function() {
        var bodyHeight = this.wrapperEl.getStyle("height").toInt();
        if (this.headerEl)
            bodyHeight -= this.headerEl.getStyle("height").toInt();

        this.containerEl.setStyle("height", bodyHeight);

        if (this.grid) {
            var controlHeight = 40,
                contEl = $(this.containerEl);
            if (contEl) {
                var controlEl = contEl.getElement(".commDateControls");
                if (controlEl)
                    controlHeight = controlEl.getHeight();
            }

            var width = contEl.getWidth() - contEl.getStyle("paddingLeft").toInt() - contEl.getStyle("paddingRight").toInt();
            var height = bodyHeight /* - controlHeight - 40 */ - contEl.getStyle("paddingBottom").toInt();

            this.grid.setSize(width, height);
        }
    }
});